import { data } from '../../svg/Analytics/data';
import { makeIcon } from '../makeIcon';

export const Analytics = makeIcon(data, 'analytics', 'Analytics');

export default Analytics;
